module.exports = __webpack_public_path__ + "img/Error@3x.61f7d2ac.png";